import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/Footer';
export const MonthlySpecial: React.FC = () => {
  return <div className="min-h-screen bg-white" data-id="element-1042">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-1043">
        <h1 className="text-5xl font-bold text-center mb-12 leading-tight" data-id="element-1044">
          Monthly Special
        </h1>

        <div className="text-center mb-8" data-id="element-1045">
          <img src="//drwzpk38qkpfb.cloudfront.net/www.wearhaus.net/uploaded/images/Redesign/Special-1.jpg?opt=w3" alt="Monthly Special" className="w-full max-w-2xl mx-auto rounded-lg shadow-lg" loading="lazy" data-id="element-1046" />
        </div>

        <h3 className="text-lg text-center leading-relaxed text-gray-700" data-id="element-1047">
          We can print any size job with a lightning fast turnaround.{' '}
          <Link to="/Contact" className="text-red-600 hover:text-red-700 underline font-medium" data-id="element-1048">
            Contact us
          </Link>{' '}
          today for a free quote!
        </h3>
      </div>
      <Footer data-id="element-1049" />
    </div>;
};